module.exports = __webpack_public_path__ + "img/double-matrix-bg.630f9709.svg";